// extracted by mini-css-extract-plugin
module.exports = {"container":"imgtxtdetail_container__3UxLf","content":"imgtxtdetail_content__2AOmz","title1Img":"imgtxtdetail_title1Img__1aSPS"};